// Polyfill URL.parse for browsers that don't support it (Chrome < 126).
// URL.parse() is a static method that returns null on invalid URLs instead of
// throwing, unlike `new URL()`. Third-party libraries (e.g. pdfjs-dist) use it,
// so browsers without it crash at render time.
if (!URL.parse) {
  URL.parse = (url, base) => {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}

